import React from "react";

function TonnageDisclaimer() {
  return (
    <div style={{ fontStyle: "italic" }}>
      <p>
        <span>
          Disclaimer: DTSC cannot guarantee that the data accurately reflect
          what was actually transported or produced.{" "}
        </span>
        <a
          href="/documents/Internal_CUPA_Disclaimer.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Click here for details.
        </a>
      </p>
    </div>
  );
}

export default TonnageDisclaimer;
